export default __webpack_public_path__ + "static/media/subscribe.5044c5e8.svg";